import { render } from "./IpsCreate.vue?vue&type=template&id=dd24b9a8"
import script from "./IpsCreate.vue?vue&type=script&lang=js"
export * from "./IpsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__